const STORAGE_KEY = 'fc_cookie_consent'
const DISMISS_KEY = 'fc_cookie_banner_dismissed'
const POLICY_VERSION = '1.0' // Increment when cookie policy changes

export default {
    state: () => ({
      showBanner: false,
      showPreferences: false,
      consentGiven: false,
      preferences: {
        strictlyNecessary: true,
        functional: true,
        analytics: true,
        marketing: true,
      },
      consentRecord: null,
    }),
    getters: {
      hasConsent: (state) => state.consentGiven,
      canUseFunctional: (state) => state.preferences.functional,
      canUseAnalytics: (state) => state.preferences.analytics,
      canUseMarketing: (state) => state.preferences.marketing,
    },
    mutations: {
    },
    actions: {
      
      cookieConsentInit(context) {
        // Check if banner was dismissed
        const dismissed = localStorage.getItem(DISMISS_KEY)
        if (dismissed) {
          context.state.showBanner = false
          return
        }

        const stored = localStorage.getItem(STORAGE_KEY)
        if (stored) {
          try {
            const record = JSON.parse(stored)
            
            // Check if policy version has changed
            if (record.policyVersion !== POLICY_VERSION) {
              // Policy changed, show banner again
              context.state.showBanner = true
              return
            }

            // Load existing consent
            context.state.consentRecord = record
            context.state.preferences = { ...record.preferences }
            context.state.consentGiven = true
            context.state.showBanner = false

            // Apply consent to scripts
            context.dispatch('applyCookieConsent')
          } catch (e) {
            console.error('Failed to parse cookie consent:', e)
            context.state.showBanner = true
          }
        } else {
          // No consent record, show banner
          context.state.showBanner = true
        }
      },
      
      dismissCookieBanner(context) {
        context.state.showBanner = false
        localStorage.setItem(DISMISS_KEY, 'true')
      },
      
      applyCookieConsent(context) {
        // Trigger event for scripts to listen to
        window.dispatchEvent(new CustomEvent('cookieConsentChanged', {
          detail: {
            preferences: context.state.preferences,
            timestamp: new Date().toISOString()
          }
        }))

        // Clear cookies if consent withdrawn
        if (!context.state.preferences.analytics) {
          context.dispatch('clearAnalyticsCookies')
        }
        if (!context.state.preferences.marketing) {
          context.dispatch('clearMarketingCookies')
        }
      },
      
      clearAnalyticsCookies() {
        // Clear Google Analytics cookies
        const analyticsCookies = ['_ga', '_gid', '_gat', '_gat_gtag_UA_']
        analyticsCookies.forEach(name => {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
        })
      },
      
      clearMarketingCookies() {
        // Clear common marketing cookies
        const marketingCookies = ['_fbp', '_fbc', '__Secure-3PAPISID']
        marketingCookies.forEach(name => {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
        })
      },

    },
};